import { Input, message } from "antd";
import { useTranslation } from "react-i18next";

interface NumericInputProps {
  maxLength: number;
  defaultValue?: string;
  minValue?: number;
  value?: string;
  onChange?: (value: string) => void;
}

const NumericInput = (props: NumericInputProps) => {
  const [t] = useTranslation("common");
  const { value, onChange } = props;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value: inputValue } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;

    // Remove non-numeric characters from the input value
    inputValue = inputValue.replace(/[^0-9.,]/g, "");

    if (reg.test(inputValue) || inputValue === "" || inputValue === "-") {
      // Check if maximum length is reached
      const maxLength = props.maxLength;
      if (inputValue.length < maxLength) {
        onChange?.(inputValue);
      } else {
        message.warning("Maximum length reached!");
      }
    }
  };
  // '.' at the end or only '-' in the input box.
  const handleBlur = () => {
    // eslint-disable-next-line no-mixed-operators
    if ((value && value.charAt(value.length - 1) === ".") || value === "-") {
      let valueTemp = value.slice(0, -1);
      onChange?.(valueTemp.replace(/0*(\d+)/, "$1"));
    }
  };

  return (
    <Input
      {...props}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={`${t("enter-text")}`}
      autoComplete="off"
    />
  );
};

export const InputNumbers = (props: NumericInputProps) => {
  return <NumericInput {...props} />;
};
